import { createAction, props } from '@ngrx/store';
import {
  VendorTagging,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';

export const addVendorTagging = createAction(
    '[Tagging] addVendorTagging',
    props<{ tagging : VendorTagging[] }>()
  );

export const updateVendorTagging = createAction(
  '[Tagging] updateVendorTagging',
  props<{ tagging : VendorTagging[] }>()
);

export const clearTaggingStore = createAction('[Tagging] clearTaggingStore');
